module.exports = __webpack_public_path__ + "img/4.d3200de9.svg";